import Styles from './UploadsTab.module.scss'
import { useObjectRef } from '@react-aria/utils'
import { forwardRef, useState } from 'react'
import { IMediaFile } from './Types'
import { DraggableShape } from '../DraggableShape/DraggableShape'
import { isVideo } from 'components/ImagePickerModal/utils'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'

type Props = {
  src: string
  'aria-label'?: string
  file: IMediaFile
  payload?: any
  onPress: (e: React.MouseEvent) => void
  size?: { width: number; height: number }
  durationContainerClassName?: string
  durationTextClassName?: string
  /** When true, native drag-to-canvas is disabled (e.g. multi-select mode). */
  disableDrag?: boolean
}

export const MediaFile = forwardRef<HTMLDivElement, Props>(
  ({ src, file, onPress, size, durationContainerClassName, durationTextClassName, disableDrag, ...rest }, fRef) => {
    const ref = useObjectRef(fRef)
    const [imgRef, setImgRef] = useState<HTMLImageElement | null>(null)

    return (
      <DraggableShape
        dragImage={() => (
          <img
            src={src}
            alt=""
            style={{ width: imgRef?.getBoundingClientRect().width, height: imgRef?.getBoundingClientRect().height }}
            draggable="false"
          />
        )}
        payload={{
          type: 'image',
          file,
          props: {
            w: 500,
          },
          ...rest.payload,
        }}
        draggableEl={imgRef}
        className={Styles.mediaFile}
        isDisabled={disableDrag || !!isVideo({ type: file.mime_type })}
      >
        <div {...rest} onClick={onPress} ref={ref} className={Styles.mediaFileThumbnail}>
          <img
            style={{ height: size?.height, width: size?.width }}
            ref={setImgRef}
            src={src}
            alt={file.title}
            draggable="false"
          />
          {file.duration && file.duration > 0 && (
            <VideoDuration
              duration={file.duration}
              containerClassName={durationContainerClassName}
              textClassName={durationTextClassName}
            />
          )}
        </div>
      </DraggableShape>
    )
  },
)
